import { MiaPlaza } from "@/Reinforced.Typings";

import mathSvg from "@theme/curriculum/subjects/minimalistic/Math.svg";
import languageArtsSvg from "@theme/curriculum/subjects/minimalistic/LanguageArts.svg";
import scienceSvg from "@theme/curriculum/subjects/minimalistic/Science.svg";
import geographyAndHistorySvg from "@theme/curriculum/subjects/minimalistic/GeographyAndHistory.svg";
import musicAndArtsSvg from "@theme/curriculum/subjects/minimalistic/MusicAndArts.svg";
import foreignLanguagesSvg from "@theme/curriculum/subjects/minimalistic/ForeignLanguages.svg";
import lifeSkillsSvg from "@theme/curriculum/subjects/minimalistic/LifeSkills.svg";
import biblicalStudiesSvg from "@theme/curriculum/subjects/minimalistic/BiblicalStudies.svg";

const minimalisticSvgs: Partial<Record<MiaPlaza.Model.Subject, string>> = {
	[MiaPlaza.Model.Subject.Math]: mathSvg,
	[MiaPlaza.Model.Subject.LanguageArts]: languageArtsSvg,
	[MiaPlaza.Model.Subject.Science]: scienceSvg,
	[MiaPlaza.Model.Subject.GeographyAndHistory]: geographyAndHistorySvg,
	[MiaPlaza.Model.Subject.MusicAndArts]: musicAndArtsSvg,
	[MiaPlaza.Model.Subject.ForeignLanguages]: foreignLanguagesSvg,
	[MiaPlaza.Model.Subject.LifeSkills]: lifeSkillsSvg,
	[MiaPlaza.Model.Subject.BiblicalStudies]: biblicalStudiesSvg,
};

/**
 * Convenience class for getting subject-specific constants.
 */
export default class SubjectHelper {
	public static GetTextClass(key: string): string {
		return `mia-text-subject-${SubjectHelper.SanitizeKeyForCss(key)}`;
	}

	public static GetBackgroundClass(key: string): string {
		return `mia-bg-subject-${SubjectHelper.SanitizeKeyForCss(key)}`;
	}

	public static GetBackgroundContrastClass(key: string): string {
		return `mia-bg-subject-contrast-${SubjectHelper.SanitizeKeyForCss(key)}`;
	}

	public static GetBackgroundImageClass(key: string): string {
		return `mia-bg-image-subject-${key}`;
	}

	public static GetTrKey(key: string): string {
		return `subject_${key}`;
	}

	public static SanitizeKeyForCss(key: string): string {
		return key.replace(/_/g, "-");
	}

	public static GetBorderClass(key: string): string {
		return `mia-border-subject-${key}`;
	}

	public static GetMinimalisticBackgroundImageClass(key: string): string {
		return `mia-bg-image-subject-minimalistic-${key}`;
	}

	public static GetMinimalisticBackgroundClass(key: string): string {
		return `mia-bg-subject-minimalistic-${key}`;
	}

	public static GetMinimalisticIconClass(key: string): string {
		return `mia-icon-subject-minimalistic-${key}`;
	}

	public static GetMinimalisticSvg(subject: MiaPlaza.Model.Subject): string {
		return minimalisticSvgs[subject] ?? "";
	}

	/**
	 * Make sure to synchronize changes here with CoreSubjects in the backend.
	 */
	public static GetCoreSubjects(): MiaPlaza.Model.Subject[] {
		return [
			MiaPlaza.Model.Subject.LanguageArts,
			MiaPlaza.Model.Subject.Math,
			MiaPlaza.Model.Subject.Science,
			MiaPlaza.Model.Subject.GeographyAndHistory,
		];
	}

	public static GetAllSubjects(): MiaPlaza.Model.Subject[] {
		return [
			...this.GetCoreSubjects(),
			MiaPlaza.Model.Subject.MusicAndArts,
			MiaPlaza.Model.Subject.ForeignLanguages,
			MiaPlaza.Model.Subject.LifeSkills,
			MiaPlaza.Model.Subject.BiblicalStudies,
		];
	}
}
